import { IonSkeletonText } from '@ionic/react';
import { thermometerOutline } from 'ionicons/icons';
import {useSuggestedTemperature} from "@/hooks/useSuggestedTemperature";
import {useRelativeTime} from "@/hooks/useRelativeTime";
import {DashboardCard} from "@/components/dashboard/DashboardCard";

export function SuggestedTemperatureWidget() {
  const { data, isLoading, error } = useSuggestedTemperature();
  const relativeTime = useRelativeTime(data?.timestamp);

  const handleViewMore = () => {
    console.log('View temperature details');
  };

  const handleSettings = () => {
    console.log('Open temperature settings');
  };

  return (
    <DashboardCard
      title="Température sirop"
      subtitle={relativeTime}
      icon={thermometerOutline}
      onAction={handleViewMore}
      onSettings={handleSettings}
      actionLabel="Voir plus"
      footer={
        data && !isLoading && !error ? (
          <div className="flex flex-col gap-1">
            <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400 footer-text">
              <span>Pour un sirop à {parseFloat(data.target_brix).toFixed(1)}°Brix</span>
              <span>Eau bou à {parseFloat(data.water_boiling_point).toFixed(2)} °C </span>
            </div>
          </div>
        ) : null
      }
    >
      {isLoading ? (
        <div className="flex flex-col items-center py-4">
          <IonSkeletonText animated style={{ width: '60%', height: '48px' }} />
          <IonSkeletonText animated style={{ width: '40%', height: '20px', marginTop: '8px' }} />
        </div>
      ) : error || !data ? (
        <div className="flex flex-col items-center py-4 text-gray-500">
          <p className="text-sm">Aucune donnée disponible</p>
        </div>
      ) : (
        <div className="flex flex-col items-center py-2">
          <div className="flex items-baseline gap-2">
            <span className="text-4xl font-bold text-gray-900 dark:text-gray-100">
              {parseFloat(data.temperature).toFixed(2)}
            </span>
          </div>

          <span className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            {data.unit}
          </span>
        </div>
      )}
    </DashboardCard>
  );
}